import { PublicPageShell, Section } from "../components/PublicPageShell";

export default function Terms() {
  return (
    <PublicPageShell overline="Rules of use" title="Terms of Use" updated="February 2026" testId="terms-page">
      <Section heading="1. Who can use SphereInvest AI">
        <p>
          You must be at least 18 years old and capable of entering into a binding contract. By creating an account
          you accept these terms. The service is provided by Three Spheres Healthcare Limited, a company registered
          in England and Wales (Company No. 14029879).
        </p>
      </Section>

      <Section heading="2. No advice relationship">
        <p>
          SphereInvest AI provides research insights, not personalised financial advice. Nothing on the platform is a
          recommendation to buy, sell or hold any investment, and no client, advisory or fiduciary relationship is
          created. The platform does not execute trades or hold client funds. It is built to support — not replace —
          your own decisions, and you remain solely responsible for them. Capital at risk: the value of investments
          can fall as well as rise.
        </p>
      </Section>

      <Section heading="3. Acceptable use">
        <ul className="list-disc pl-5 space-y-2">
          <li>Don&apos;t attempt to breach security, scrape at scale, resell platform output, or misuse AI features.</li>
          <li>Don&apos;t present platform output to others as personalised financial advice.</li>
          <li>One account per person; keep your credentials secure. Fair-use limits apply to AI features.</li>
        </ul>
      </Section>

      <Section heading="4. Subscriptions and cancellation">
        <p>
          Premium costs £9.99 per month, billed via PayPal. You can cancel at any time in the app (Upgrade page →
          Cancel subscription); Premium access continues until the end of the period you have paid for, and no further
          payments are taken. Deleting your account also cancels an active subscription. Prices may change with
          reasonable notice; changes apply from your next billing period.
        </p>
      </Section>

      <Section heading="5. Data and availability">
        <p>
          Market data is sourced from third parties, is typically delayed or end-of-day, may be cached up to 12 hours,
          and is provided "as is" — we cannot guarantee its accuracy or completeness. AI outputs are probabilistic and
          can be wrong. The service may be modified, interrupted or discontinued; we aim for, but do not guarantee,
          continuous availability.
        </p>
      </Section>

      <Section heading="6. Liability">
        <p>
          To the maximum extent permitted by law, we are not liable for investment losses, decisions made in reliance
          on platform output, data inaccuracies, or indirect and consequential losses. Our total aggregate liability
          in respect of the service is limited to the amount you paid us in the 12 months before the claim. Nothing in
          these terms excludes liability that cannot lawfully be excluded (e.g. fraud).
        </p>
      </Section>

      <Section heading="7. Governing law">
        <p>
          These terms are governed by the laws of England and Wales, and the courts of England and Wales have
          exclusive jurisdiction. Contact: <a href="mailto:info@threesphereshealthcare.org" className="text-primary hover:underline">info@threesphereshealthcare.org</a>.
        </p>
      </Section>
    </PublicPageShell>
  );
}
